export default "__VITE_ASSET__7vHtbW4y__"